// frontend/src/api/aiCallLog.ts
import {
  AICallLogFilter,
  AICallLogListResponse,
  AICallLogItem,
  BodyResponse,
} from '../types/aiCallLog';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8081/api';
const PATH = '/admin/ai-call-logs';

function getToken(): string {
  return localStorage.getItem('token') || '';
}

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const token = getToken();
  const response = await fetch(`${API_BASE}${url}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options?.headers,
    },
    ...options,
  });
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('未登录');
  }
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || 'Request failed');
  }
  return response.json();
}

function flatten(filter: AICallLogFilter): Record<string, string> {
  const out: Record<string, string> = {};
  Object.entries(filter).forEach(([k, v]) => {
    if (v === null || v === undefined || v === '') return;
    if (Array.isArray(v)) {
      if (v.length === 0) return;
      out[k] = v.join(',');
    } else {
      out[k] = String(v);
    }
  });
  return out;
}

function buildQuery(params: Record<string, string>): string {
  const qs = new URLSearchParams(params).toString();
  return qs ? `?${qs}` : '';
}

export async function listAICallLogs(
  filter: AICallLogFilter,
): Promise<AICallLogListResponse> {
  const qs = buildQuery(flatten(filter));
  return request<AICallLogListResponse>(`${PATH}${qs}`);
}

export async function getAICallLog(id: string): Promise<AICallLogItem> {
  return request<AICallLogItem>(`${PATH}/${encodeURIComponent(id)}`);
}

export async function getRequestBody(id: string): Promise<BodyResponse> {
  return request<BodyResponse>(`${PATH}/${encodeURIComponent(id)}/request`);
}

export async function getResponseBody(id: string): Promise<BodyResponse> {
  return request<BodyResponse>(`${PATH}/${encodeURIComponent(id)}/response`);
}

export interface AICallLogFacets {
  platforms: string[];
  steps: string[];
}

export async function getFacets(): Promise<AICallLogFacets> {
  return request<AICallLogFacets>(`${PATH}/facets`);
}
